/* McDuffy — Scroll Reveal + Header Scroll Behavior + Site-Wide Animations */
(function() {
  'use strict';

  /* Search Console cache guard: stale Shopify page-cache HTML can retain old
     FAQ/Product JSON-LD even when the live theme source is clean. Google renders
     JavaScript, so remove those stale rich-result blocks from the rendered DOM. */
  (function sanitizeStaleStructuredData() {
    var isProductPage = document.body && document.body.classList.contains('template-product');

    function shouldRemoveJsonLd(text) {
      if (!text) return false;
      if (text.indexOf('"FAQPage"') !== -1 || text.indexOf("'FAQPage'") !== -1) return true;
      if (!isProductPage && (text.indexOf('"Product"') !== -1 || text.indexOf("'Product'") !== -1)) return true;

      try {
        JSON.parse(text);
      } catch (e) {
        return true;
      }

      return false;
    }

    function run() {
      var scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(function(script) {
        if (shouldRemoveJsonLd(script.textContent || '')) {
          script.parentNode && script.parentNode.removeChild(script);
        }
      });
      document.documentElement.setAttribute('data-mcduffy-jsonld-sanitized', '2026-06-09-v1');
    }

    run();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      setTimeout(run, 0);
    }
  })();

  /* --- IntersectionObserver for .mcduffy-reveal elements --- */
  var revealEls = document.querySelectorAll('.mcduffy-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealEls.forEach(function(el) { observer.observe(el); });
  } else {
    revealEls.forEach(function(el) { el.classList.add('is-visible'); });
  }

  /* --- Header: fixed overlay with scroll-based color changes --- */
  var header = document.querySelector('store-header') || document.querySelector('.header');
  var headerInner = document.querySelector('.header');
  var hero = document.querySelector('.mcduffy-hero');
  var body = document.body;

  /* Determine if we're on the homepage (hero present) */
  var isHomepage = body.classList.contains('template-index');

  /* --- Logo swap: use black script logo for scrolled state --- */
  var logoImg = document.querySelector('.header__logo .logo__link img');
  var originalLogoSrc = logoImg ? logoImg.getAttribute('src') : null;
  var originalLogoSrcset = logoImg ? logoImg.getAttribute('srcset') : null;
  var blackLogoSrc = window.__mcduffyBlackLogoUrl || null;

  var logoIsBlack = null; /* Track current logo state to avoid redundant swaps */
  function swapLogo(useBlack) {
    if (!logoImg || !blackLogoSrc) return;
    if (useBlack === logoIsBlack) return; /* Skip if already correct */
    logoIsBlack = useBlack;
    if (useBlack) {
      logoImg.setAttribute('src', blackLogoSrc);
      if (logoImg.hasAttribute('srcset')) logoImg.removeAttribute('srcset');
    } else if (originalLogoSrc) {
      logoImg.setAttribute('src', originalLogoSrc);
      if (originalLogoSrcset) logoImg.setAttribute('srcset', originalLogoSrcset);
    }
  }

  if (headerInner) {
    /* Cache hero height to avoid layout thrashing on every scroll */
    var cachedHeroBottom = hero ? hero.offsetHeight - 80 : 0;
    var lastScrollState = null; /* Track state to avoid redundant classList writes */

    window.addEventListener('resize', function() {
      cachedHeroBottom = hero ? hero.offsetHeight - 80 : 0;
    }, { passive: true });

    function updateHeader() {
      var scrollY = window.scrollY || window.pageYOffset;

      if (isHomepage && hero) {
        var newState = scrollY > cachedHeroBottom ? 'scrolled' : 'on-hero';
        if (newState === lastScrollState) return; /* Skip if no change */
        lastScrollState = newState;
        if (newState === 'scrolled') {
          body.classList.add('header-scrolled');
          body.classList.remove('header-on-hero');
          swapLogo(true);
        } else {
          body.classList.remove('header-scrolled');
          body.classList.add('header-on-hero');
          swapLogo(false);
        }
      } else {
        /* Non-homepage pages: transparent at top, solid on scroll */
        var newState = scrollY > 60 ? 'scrolled' : 'at-top';
        if (newState === lastScrollState) return; /* Skip if no change */
        lastScrollState = newState;
        if (newState === 'scrolled') {
          body.classList.add('header-scrolled');
          body.classList.remove('header-at-top');
          swapLogo(true);
        } else {
          body.classList.remove('header-scrolled');
          body.classList.add('header-at-top');
          swapLogo(true); /* dark logo — cream bg is light */
        }
      }
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* --- Auto-add scroll reveal to homepage sections --- */
  /* NOTE: editorial, compare, timeline, testimonials have their own
     is-revealed observers in their liquid files (Phase 4 animations).
     Only sections WITHOUT self-contained scripts are listed here. */
  var sections = document.querySelectorAll(
    '.mcduffy-stats, .mcduffy-deeper, ' +
    '.mcduffy-newsletter, .mcduffy-press, ' +
    '.mcduffy-feature, .mcduffy-seo'
  );
  if (sections.length && 'IntersectionObserver' in window) {
    var sectionObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          sectionObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(1.875rem)';
      el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
      sectionObs.observe(el);
    });
  }

  /* --- Staggered child animations for grid/card containers --- */
  /* NOTE: timeline__grid and editorial__container removed — Phase 4 CSS handles them.
     nutrition__categories removed — has its own scroll-based setActive(). */
  var staggerContainers = document.querySelectorAll(
    '.mcduffy-deeper__scroll, .mcduffy-stats__container, ' +
    '.mcduffy-press__logos'
  );

  if (staggerContainers.length && 'IntersectionObserver' in window) {
    var staggerObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var children = Array.from(entry.target.children);
          /* Set initial hidden state + per-child stagger delay */
          children.forEach(function(child, i) {
            child.style.opacity = '0';
            child.style.transform = 'translateY(1.25rem)';
            child.style.transition = 'opacity 0.6s ease ' + (i * 0.1) + 's, transform 0.6s ease ' + (i * 0.1) + 's';
          });
          /* Single rAF to batch all reveal writes together */
          requestAnimationFrame(function() {
            children.forEach(function(child) {
              child.style.opacity = '1';
              child.style.transform = 'translateY(0)';
            });
          });
          staggerObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    staggerContainers.forEach(function(container) {
      staggerObs.observe(container);
    });
  }

  /* --- Hero parallax-lite: subtle movement on scroll --- */
  var heroProduct = document.querySelector('.mcduffy-hero__product');
  if (heroProduct && hero) {
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var scrollY = window.scrollY || window.pageYOffset;
          if (scrollY < window.innerHeight) {
            heroProduct.style.transform = 'translateY(calc(-50% + ' + (scrollY * 0.12) + 'px))';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- Number counter animation for stats section --- */
  var statNumbers = document.querySelectorAll('.mcduffy-stats__number');
  if (statNumbers.length && 'IntersectionObserver' in window) {
    function animateCounter(el) {
      var text = el.textContent.trim();
      // Extract number and any suffix (%, +, k, etc.)
      var match = text.match(/^([^\d]*)([\d,.]+)(.*)$/);
      if (!match) return;

      var prefix = match[1];
      var numStr = match[2];
      var suffix = match[3];
      var hasDecimal = numStr.indexOf('.') !== -1;
      var target = parseFloat(numStr.replace(/,/g, ''));
      var hasCommas = numStr.indexOf(',') !== -1;

      if (isNaN(target)) return;

      var duration = 1500;
      var startTime = null;

      function easeOutQuart(t) {
        return 1 - Math.pow(1 - t, 4);
      }

      function formatNumber(n) {
        if (hasDecimal) {
          var decimals = numStr.split('.')[1].length;
          n = n.toFixed(decimals);
        } else {
          n = Math.round(n);
        }
        if (hasCommas) {
          n = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return prefix + n + suffix;
      }

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var easedProgress = easeOutQuart(progress);
        var current = target * easedProgress;
        el.textContent = formatNumber(current);
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }

      el.textContent = formatNumber(0);
      requestAnimationFrame(step);
    }

    var statsObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          statsObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    statNumbers.forEach(function(el) { statsObs.observe(el); });
  }

  /* --- Hover micro-interactions — moved to CSS for performance --- */
  /* See mcduffy-maev.css for .mcduffy-deeper__card:hover etc. */

  /* ==========================================================================
     CONVERSION OPTIMIZATION — Premium Enhancements
     ========================================================================== */

  /* --- Page load fade-in --- */
  requestAnimationFrame(function() {
    document.body.classList.add('is-loaded');
  });

  /* --- Scroll progress bar --- */
  var progressBar = document.createElement('div');
  progressBar.className = 'mcduffy-scroll-progress';
  document.body.appendChild(progressBar);
  var progressTicking = false;
  window.addEventListener('scroll', function() {
    if (!progressTicking) {
      requestAnimationFrame(function() {
        var scrollTop = window.scrollY || window.pageYOffset;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        progressBar.style.width = progress + '%';
        progressTicking = false;
      });
      progressTicking = true;
    }
  }, { passive: true });

  /* --- Floating sticky CTA removed — was overlapping bottom nav --- */

  /* --- Magnetic buttons (desktop only) --- */
  if (window.matchMedia('(hover: hover)').matches) {
    var magneticBtns = document.querySelectorAll(
      '.mcduffy-hero__cta, .spot__cta, .mcduffy-how-it-works__cta'
    );
    magneticBtns.forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        var rect = this.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var dx = (e.clientX - cx) * 0.15;
        var dy = (e.clientY - cy) * 0.15;
        this.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
      });
      btn.addEventListener('mouseleave', function() {
        this.style.transform = '';
        this.style.transition = 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)';
        setTimeout(function() { btn.style.transition = ''; }, 300);
      });
    });
  }

  /* --- Clean up stagger inline styles after animation completes --- */
  setTimeout(function() {
    var staggered = document.querySelectorAll('[data-stagger]');
    staggered.forEach(function(el) {
      if (el.classList.contains('is-visible')) {
        el.style.removeProperty('animation-delay');
      }
    });
  }, 3000);

  /* Product page guard: fixes stale cached section JS while Shopify catches up. */
  (function productMobileRuntimeGuard() {
    if (!document.body.classList.contains('template-product')) return;
    if (window.location.pathname.indexOf('/products/mcduffys-gently-home-cooked-complete-dog-food') === -1) return;

    try {
      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    } catch (e) {}

    function forceTop() {
      window.scrollTo(0, 0);
      if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }

    function clampQuantity() {
      var input = document.getElementById('maev-ot-qty') || document.getElementById('maev-quantity');
      if (!input) return;
      input.setAttribute('min', '1');
      input.setAttribute('max', '50');
      var current = parseInt(input.value || '1', 10);
      if (isNaN(current)) current = 1;
      var next = Math.max(1, Math.min(50, current));
      if (String(input.value) !== String(next)) {
        input.value = String(next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function applyGuards() {
      forceTop();
      clampQuantity();
    }

    applyGuards();
    document.addEventListener('DOMContentLoaded', applyGuards, { once: true });
    window.addEventListener('pageshow', applyGuards);
    document.addEventListener('input', function(event) {
      if (event.target && (event.target.id === 'maev-ot-qty' || event.target.id === 'maev-quantity')) {
        clampQuantity();
      }
    }, true);

    [60, 250, 750, 1500].forEach(function(delay) {
      setTimeout(applyGuards, delay);
    });
  })();

})();

/* ============================================================
   UNIVERSAL CONTRAST GUARD (June 2026)
   Dark text must never sit on a dark (brand-green/black) background.
   This class of bug shipped repeatedly (black-on-black cart badge,
   dimmed manifesto text), so it's now fixed at runtime, universally:
   after load, any text element whose computed color AND effective
   background are both dark gets recolored to brand cream. Elements
   with their own light background (e.g. yellow CTAs inside dark
   sections) are naturally exempt — we check the NEAREST painted
   background, not the section's.
   ============================================================ */
(function () {
  'use strict';

  function parseRGB(str) {
    var m = /rgba?\(([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?\)/.exec(str || '');
    if (!m) return null;
    return { r: +m[1], g: +m[2], b: +m[3], a: m[4] === undefined ? 1 : +m[4] };
  }

  function luminance(c) {
    return (0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b) / 255;
  }

  function effectiveBg(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      var bg = parseRGB(getComputedStyle(node).backgroundColor);
      if (bg && bg.a > 0.5) return bg;
      node = node.parentElement;
    }
    return { r: 255, g: 255, b: 255, a: 1 };
  }

  function guard() {
    var selector = 'p, h1, h2, h3, h4, h5, h6, span, li, a, b, em, strong, small, figcaption, blockquote, td, th, label, dt, dd';
    var nodes = document.body.querySelectorAll(selector);
    var fixed = 0;
    for (var i = 0; i < nodes.length && fixed < 400; i++) {
      var el = nodes[i];
      if (!el.firstChild || el.firstChild.nodeType !== 3 || !el.textContent.trim()) continue; // direct text only
      var color = parseRGB(getComputedStyle(el).color);
      if (!color || luminance(color) > 0.3) continue;            // text is not dark
      var bg = effectiveBg(el);
      if (luminance(bg) > 0.25) continue;                        // background is not dark
      el.style.setProperty('color', '#F5F0E8', 'important');     // brand cream
      fixed++;
    }
    if (fixed) console.warn('[ContrastGuard] Recolored ' + fixed + ' dark-on-dark text element(s)');
  }

  function run() {
    if ('requestIdleCallback' in window) requestIdleCallback(guard, { timeout: 3000 });
    else setTimeout(guard, 1200);
  }

  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run);
})();
